import { render, staticRenderFns } from "./CardNews.vue?vue&type=template&id=4f2d5de2&scoped=true"
import script from "./CardNews.vue?vue&type=script&lang=ts"
export * from "./CardNews.vue?vue&type=script&lang=ts"
import style0 from "./CardNews.vue?vue&type=style&index=0&id=4f2d5de2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2d5de2",
  null
  
)

export default component.exports